import {Directive, ElementRef, Input, Renderer2} from '@angular/core';

@Directive({
  selector: 'img[showPlaceholderOnError], img[hideImageOnError]',
  host: {
    '(error)': 'onError()',
    '[src]': 'src'
  }
})
export class ImageSrcOnerrorValidatorDirective {
  @Input() src: string;
  @Input() showPlaceholderOnError: boolean;
  @Input() hideImageOnError: boolean;

  private hasAlreadyValidateImg: boolean = false;
  
  constructor(
      private elRef: ElementRef,
      private renderer2: Renderer2
  ) {}

  public onError(): void {
    // inserisco nel src l'url del placeholder di default
    if (this.showPlaceholderOnError && !this.hasAlreadyValidateImg) {
      this.src = 'assets/images/placeholders/img.png';
    }
    
    // nascondo l'img se ho impostato il booleano dedicato
    if (this.hideImageOnError && !this.hasAlreadyValidateImg) {
      this.renderer2.setStyle(this.elRef.nativeElement, 'display', 'none');
    }

    this.hasAlreadyValidateImg = true;
  }
}
